import { render } from "./ButtonConversation.vue?vue&type=template&id=07c2d7f6&scoped=true"
import script from "./ButtonConversation.vue?vue&type=script&lang=js"
export * from "./ButtonConversation.vue?vue&type=script&lang=js"

import "./ButtonConversation.vue?vue&type=style&index=0&id=07c2d7f6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-07c2d7f6"

export default script